// md5ClientS3.mjs
import { S3Client, S3ClientConfig, ServiceInputTypes, ServiceOutputTypes } from '@aws-sdk/client-s3';
import { HandlerExecutionContext, InitializeHandler } from '@smithy/types/dist-types/middleware';
import { Buffer } from 'buffer';
import crypto from 'crypto';

/**
 * Creates an S3 client that uses MD5 checksums for DeleteObjects operations
 */
export function createS3ClientWithMD5(config: S3ClientConfig) {
    const client = new S3Client(config);

    // Define the middleware function
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const md5Middleware = (next: InitializeHandler<ServiceInputTypes, ServiceOutputTypes>, context: HandlerExecutionContext) => async (args: any) => {
        // Check if this is a DeleteObjects command
        const isDeleteObjects = context.commandName === 'DeleteObjectsCommand';

        if (!isDeleteObjects) {
            return next(args);
        }

        const headers = args.request.headers;

        // Remove any checksum headers added by default middleware
        // This ensures our Content-MD5 is the primary integrity check
        Object.keys(headers).forEach((header) => {
            const lowerHeader = header.toLowerCase();
            if (lowerHeader.startsWith('x-amz-checksum-') || lowerHeader.startsWith('x-amz-sdk-checksum-')) {
                delete headers[header];
            }
        });

        // Add Content-MD5 header
        if (args.request.body) {
            const bodyContent = Buffer.from(args.request.body);
            headers['Content-MD5'] = crypto.createHash('md5').update(bodyContent).digest('base64');
        }

        return await next(args);
    };

    // Add the middleware relative to the flexible checksums middleware
    // This ensures it runs after default checksums might be added, but before signing
    client.middlewareStack.addRelativeTo(md5Middleware, {
        relation: 'after',
        toMiddleware: 'serializerMiddleware',
        name: 'addMD5ChecksumForDeleteObjects', // Optional: Name it whatever you'd like
        tags: ['MD5_FALLBACK'],
    });

    return client;
}